module.exports = __webpack_public_path__ + "img/cocteleria_7.dfd358e1.jpeg";